import styles from "./ForgotPasswordPopup.module.scss";
import FormField from "components/FormField";
import { useState } from "react";
import Button, { SIZE } from "components/Button";
import classnames from "classnames";
import userService from "services/user.service";

const ForgotPasswordPopup = ({ setShowPopup }) => {
  const [emailValue, setEmailValue] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setEmailValue(e.target.value);
    setEmailError("");
    setLoading(false);
  };

  const validate = (value) => {
    let error = "";

    const regex =
      /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!value) {
      error = "Email is required!";
    } else if (!regex.test(value)) {
      error = "Please, enter a valid email";
    }

    return error;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    setEmailError(validate(emailValue));

    validate(emailValue) === "" &&
      userService.resetPassword(emailValue).then(
        (response) => {
          response && setSuccess(true);
        },
        (error) => {
          const _content =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();

          console.error(_content);
        },
      );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          {success ? "Sent successfully!" : "Forgot Password"}
        </h1>
        <p className={classnames(styles.description)}>
          {success
            ? "A link to reset your password has been sent to your email."
            : "Enter your Email and we’ll send you a link to reset your password."}
        </p>
      </div>
      {!success && (
        <>
          <form
            className={styles.form}
            method="POST"
            action="submit"
            onSubmit={handleOnSubmit}
          >
            <FormField
              labelText="Email"
              fieldName="email"
              value={emailValue}
              onChange={handleChange}
              className={styles.input}
              error={emailError}
            />
            <p
              className={classnames(
                styles.error_message,
                emailError !== "" && styles.active,
              )}
            >
              {emailError}
            </p>

            <Button
              type="submit"
              size={SIZE.LARGE}
              className={styles.button}
              disabled={loading}
            >
              Submit
            </Button>
          </form>

          <button
            className={classnames("link", styles.link)}
            onClick={() => setShowPopup(false)}
          >
            Back to Login
          </button>
        </>
      )}
    </div>
  );
};

export default ForgotPasswordPopup;
